import React from 'react';

import { MainView } from '@repo/ui/Views';
import AccountSettingsTabNav from '../components/account/AccountSettingsTabNav';
import AccountContactForm from '../components/account/AccountContactForm';
import { useQuery } from '@apollo/client/react';
import GET_PRIMARY_CONTACTS_FOR_ACCOUNT_Q from '../gql/getPrimaryContactsForAccount.gql';

import { useAccount } from '@/hooks/useAccount';
import { ACCOUNT_CONTACT_KEYS, AccountContactKey } from '@repo/types/accountContacts';
import { Mercury } from '@repo/types/Models';

type AccountPrimaryContact = Mercury.Models.AccountPrimaryContact;

const AccountContacts = () => {
  const currentAccount = useAccount();
  const { loading, data, refetch } = useQuery(GET_PRIMARY_CONTACTS_FOR_ACCOUNT_Q, {
    variables: {
      first: 10,
      id: currentAccount?.id,
    },
  });

  const contacts: AccountPrimaryContact[] =
    data?.primaryContactsForAccount?.edges?.map(
      (edge: { node: AccountPrimaryContact }) => edge.node
    ) || [];

  const contactsByKey = ACCOUNT_CONTACT_KEYS.reduce(
    (acc, key) => {
      acc[key] = contacts.find((c) => c.label === key) || null;
      return acc;
    },
    {} as Record<AccountContactKey, AccountPrimaryContact | null>
  );

  return (
    <MainView title={`Manage Account: ${currentAccount.name}`} loading={loading}>
      <AccountSettingsTabNav />

      {!loading && (
        <div className="grid grid-cols-1 gap-6">
          {ACCOUNT_CONTACT_KEYS.map((contactKey) => (
            <AccountContactForm
              key={contactKey}
              contactKey={contactKey}
              contact={contactsByKey[contactKey]}
              refetch={refetch}
            />
          ))}
        </div>
      )}
    </MainView>
  );
};

export default AccountContacts;
